import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import coursCss from "./AllCourses.module.css";
import course1 from "../../asset/Image/course1.jpg";
import course2 from "../../asset/Image/course2.jpg";
import course3 from "../../asset/Image/course3.jpg";
import course4 from "../../asset/Image/course4.jpg";
import { Link } from "react-router-dom";
import RestClient from "../../RestApi/RestClient";
import AppUrl from "../../RestApi/AppUrl";
import Loader from "../../shared/Loader/Loader";
import WentWrong from "../../shared/WentWrong/WentWrong";
import Bounce from "react-reveal/Bounce";
import Fade from "react-reveal/Fade";

export default function AllCourses() {
  const [allCourses, setAllCourse] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    RestClient.GetRequest(AppUrl.AllCourse).then((result) => {
      if (result == null) {
        setError(true);
      } else {
        setAllCourse(result);
        setLoading(false);
      }
    });
  }, []);
  return (
    <>
      {loading && <Loader />}
      <Container className="my-5">
        {!error ? (
          <Row>
            {allCourses.map((allcourse, i) => {
              return (
                <Col lg={6} md={12} sm={12} key={i}>
                  <Row className="mb-5">
                    <Col lg={6} md={12} sm={12}>
                      <Fade top>
                        <img
                          src={allcourse.course_image}
                          alt=""
                          className="img-fluid"
                        />
                      </Fade>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <Bounce left>
                        <h5 className={`${coursCss.title} text-justify`}>
                          {allcourse.short_title}
                        </h5>
                        <h5 className={`${coursCss.description} text-justify`}>
                          {allcourse.short_description}
                        </h5>
                        <Link
                          to={`/courseDetails/${allcourse.id}/${allcourse.short_title}`}
                          className={`${coursCss.button} text-justify`}
                        >
                          View details
                        </Link>
                      </Bounce>
                    </Col>
                  </Row>
                </Col>
              );
            })}
          </Row>
        ) : (
          <WentWrong />
        )}
      </Container>
    </>
  );
}
